import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals, pipe } from "ramda";
import { MultiRangeInput } from "@interdependence-ui";
import { collectPeriodsBetween, getPeriod, arrayAnnotationDate, truncatedPeriodAnnotation } from "utils/periods";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default /*#__PURE__*/memo(function SelectPeriodRange(props) {
  var id = props.id,
    _onChange = props.onChange,
    periodType = props.periodType,
    dateFrom = props.dateFrom,
    dateTo = props.dateTo,
    earliestDataDate = props.earliestDataDate,
    lastDataDate = props.lastDataDate,
    showLegend = props.showLegend;
  var disabled = !earliestDataDate || !lastDataDate || !periodType || !dateFrom || !dateTo;
  var getTranslatedDate = function getTranslatedDate(periodType, date) {
    return pipe(function () {
      return arrayAnnotationDate(periodType, date);
    }, function (arrayDate) {
      return truncatedPeriodAnnotation(periodType, arrayDate, true);
    })();
  };
  var dates = earliestDataDate && lastDataDate && periodType && collectPeriodsBetween(periodType, getPeriod(periodType, earliestDataDate), getPeriod(periodType, lastDataDate)).map(function (x) {
    return _objectSpread(_objectSpread({}, x), {}, {
      id: x.start,
      nameFrom: getTranslatedDate(periodType, x.start),
      nameTo: getTranslatedDate(periodType, x.end)
    });
  }) || [{
    id: "dateFrom",
    nameFrom: "-",
    nameTo: "-"
  }, {
    id: "dateTo",
    nameFrom: "-",
    nameTo: "-"
  }];
  var current = earliestDataDate && lastDataDate && dateFrom && dateTo && periodType && [{
    id: dateFrom,
    nameFrom: getTranslatedDate(periodType, getPeriod(periodType, dateFrom).start)
  }, {
    id: dateTo,
    nameTo: getTranslatedDate(periodType, getPeriod(periodType, dateTo).end)
  }] || [{
    id: "dateFrom",
    nameFrom: "-",
    nameTo: "-"
  }, {
    id: "dateTo",
    nameFrom: "-",
    nameTo: "-"
  }];
  return /*#__PURE__*/_jsx(MultiRangeInput, _objectSpread(_objectSpread({
    id: "select-period-range-".concat(id || ""),
    legend: "V\xE4lj tidsspan",
    hideLegend: !showLegend,
    selectable: dates,
    current: current
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    disabled: disabled,
    onChange: function onChange(idx) {
      if (!dates[idx[0]]) return;
      _onChange({
        dateFrom: dates[idx[0]].start,
        dateTo: dates[idx[1]].end
      });
    }
  }), dates);
}, function (prev, curr) {
  return equals(curr, prev);
});